<div class="pro-widget pro-widget--table" [ngClass]="{ 'printing': isPrinting() }">
  <div class="pro-widget__content">
    <table class="report">
      <thead>
        <tr>
          <th>Quarterly Summary {{ date() | date: 'MMM yyyy' }}</th>
          <th colspan="2" class="center">{{ institution().name }}</th>
          <th colspan="2" class="center">Peer Group</th>
          <th colspan="2" class="center">Top Institution</th>
        </tr>
      </thead>
      @if (metrics().length == 0) {
      <tbody>
        <tr>
          <td colspan="7" class="no-data">No data available</td>
        </tr>
      </tbody>
      } @else {
      <tbody>
        @for (section of sections(); track section) {
        <tr class="report__title">
          <td class="bold left">{{ section }}</td>
          <td>Value</td>
          <td>Rank</td>
          <td>Average</td>
          <td>
            <svg class="icon report__arrow-up green-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.1 145.7c-3.81 8.758-12.45 14.42-21.1 14.42L184 160.1V488c0 13.25-10.75 24-24 24s-24-10.75-24-24V160.1L55.1 160.1c-9.547 0-18.19-5.658-22-14.42C30.19 136.9 31.92 126.7 38.41 119.8l104-112.1c9.5-10.23 25.69-10.23 35.19 0l104 112.1C288.1 126.7 289.8 136.9 285.1 145.7z" /></svg>
            &nbsp;
            <svg class="icon report__arrow-down red-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34 366.3c3.811-8.758 12.45-14.42 21.1-14.42h80V24c0-13.25 10.75-24 23.1-24s24 10.75 24 24v327.9h79.1c9.547 0 18.19 5.66 22 14.42c3.811 8.754 2.076 18.95-4.408 25.94l-104 112.1c-9.5 10.23-25.69 10.23-35.19 0l-104-112.1C31.92 385.3 30.19 375.1 34 366.3z" /></svg>
          </td>
          <td class="left">Name</td>
          <td>Value</td>
        </tr>
        @for (metric of groupedMetrics()[section]; track metric; let even = $even) {
        <tr (click)="onToggleDetail(metric)" [ngClass]="{ 'even': even }">
          <td class="title">
            <span [innerHtml]="getDisplayTitle(metric)"></span>
          </td>
          <td>
            @if (metric.institutionValue == undefined) {
            &#8212;
            } @else {
            {{ getDisplayValue(metric.displayType, metric.institutionValue) }}
            }
          </td>
          <td>
            @if (metric.institutionRank == undefined) {
            &#8212;
            } @else {
            {{ metric.institutionRank }}
            <span class="tooltip">{{ metric.institutionRank }} of {{ metric.institutionsReporting }} banks reporting</span>
            }
          </td>
          <td>
            @if (metric.groupValue == undefined) {
            &#8212;
            } @else {
            {{ getDisplayValue(metric.displayType, metric.groupValue) }}
            }
          </td>
          @if (metric.institutionValue == undefined || metric.groupValue == undefined) {
          <td class="difference">
            &#8212;
          </td>
          } @else {
          <td class="difference" [ngClass]="{ 'red': metric.difference < 0 && metric.rankSort != 'N', 'green': metric.difference >= 0 && metric.rankSort != 'N' }">
            @if (metric.rankSort == 'N') {
            @if (metric.difference >= 0) {
            <svg class="icon report__arrow-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.1 145.7c-3.81 8.758-12.45 14.42-21.1 14.42L184 160.1V488c0 13.25-10.75 24-24 24s-24-10.75-24-24V160.1L55.1 160.1c-9.547 0-18.19-5.658-22-14.42C30.19 136.9 31.92 126.7 38.41 119.8l104-112.1c9.5-10.23 25.69-10.23 35.19 0l104 112.1C288.1 126.7 289.8 136.9 285.1 145.7z" /></svg>
            } @else {
            <svg class="icon report__arrow-down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34 366.3c3.811-8.758 12.45-14.42 21.1-14.42h80V24c0-13.25 10.75-24 23.1-24s24 10.75 24 24v327.9h79.1c9.547 0 18.19 5.66 22 14.42c3.811 8.754 2.076 18.95-4.408 25.94l-104 112.1c-9.5 10.23-25.69 10.23-35.19 0l-104-112.1C31.92 385.3 30.19 375.1 34 366.3z" /></svg>
            }
            } @else {
            @if (metric.difference >= 0 ) {
            <svg class="icon report__arrow-up green-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M285.1 145.7c-3.81 8.758-12.45 14.42-21.1 14.42L184 160.1V488c0 13.25-10.75 24-24 24s-24-10.75-24-24V160.1L55.1 160.1c-9.547 0-18.19-5.658-22-14.42C30.19 136.9 31.92 126.7 38.41 119.8l104-112.1c9.5-10.23 25.69-10.23 35.19 0l104 112.1C288.1 126.7 289.8 136.9 285.1 145.7z" /></svg>
            } @else {
            <svg class="icon report__arrow-down red-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M34 366.3c3.811-8.758 12.45-14.42 21.1-14.42h80V24c0-13.25 10.75-24 23.1-24s24 10.75 24 24v327.9h79.1c9.547 0 18.19 5.66 22 14.42c3.811 8.754 2.076 18.95-4.408 25.94l-104 112.1c-9.5 10.23-25.69 10.23-35.19 0l-104-112.1C31.92 385.3 30.19 375.1 34 366.3z" /></svg>
            }
            }
            {{ getDisplayDifference(metric.displayType, metric.difference) }}
          </td>
          }
          <td>
            @if (metric.topInstitutionLabel) {
            <span class="left">{{ metric.topInstitutionLabel }}</span>
            <span class="tooltip">
              {{ metric.topInstitutionLabel }}
            </span>
            } @else {
            &#8212;
            }
          </td>
          <td>
            @if (metric.topInstitutionValue) {
            {{ getDisplayValue(metric.displayType, metric.topInstitutionValue) }}
            } @else {
            &#8212;
            }
          </td>
        </tr>
        }
        }
      </tbody>
      }
    </table>
    @if (loading) {
    <div class="table-update">
      <div class="table-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    }
  </div>
</div>

<div class="drawer drawer--bottom" [ngClass]="{ 'drawer--open': isDrawerOpen }">
  <div class="card card--drawer">
    <div class="card__title">{{ metric?.rowTitle }} <div class="drawer__close" (click)="closeDrawer()"><svg class="icon drawer__close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M232 344V280H168C154.7 280 144 269.3 144 256C144 242.7 154.7 232 168 232H232V168C232 154.7 242.7 144 256 144C269.3 144 280 154.7 280 168V232H344C357.3 232 368 242.7 368 256C368 269.3 357.3 280 344 280H280V344C280 357.3 269.3 368 256 368C242.7 368 232 357.3 232 344zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" /></svg></div></div>
    <div class="card__content">
      <div class="flex">
        <div class="flex__item flex__item--dbl">
          <p class="row-info">{{ metric?.rowInformation }}</p>
        </div>
        <div class="flex__item flex__item--col flex__item--trpl flex__item--group">
          <div class="flex__item flex__item--col">
            <app-metric-quarterly-group [metric]="metric"></app-metric-quarterly-group>
          </div>
          <div class="flex__item flex__item--col">
            <app-percentile-quarterly [metric]="metric"></app-percentile-quarterly>
          </div>
        </div>
      </div>
      <app-rank-quarterly [metric]="metric"></app-rank-quarterly>
    </div>
  </div>
</div>

<div #dialog></div>
